// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5675) return "static/chunks/5675-d44ccffa4202f146.js";
	if (chunkId === 5518) return "static/chunks/5518-7e28c3da71105415.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"2580":"159c99e4335237ac","3937":"12f6b13a0d70ba95","4771":"ebd58a5bbd7e9d3f","5279":"44d0109d3a741179","6202":"85ca5a5b00e01ee9","7229":"554f4e11cdd0f29c"}[chunkId] + ".js";
};